export default __webpack_public_path__ + "static/media/support.fbb18223.svg";